<template>
  <span
    class="tag"
    :class="{ 'is-success': status === 'open', 'is-dark': status === 'closed' }"
  >
    {{ $t("support_ticket.status." + status) }}
  </span>
</template>

<script>
import i18n from "./../i18n";

export default {
  i18n,

  props: ["status"]
};
</script>
